import React, { useRef, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaRegEye, FaRegCommentDots, FaRegCalendarAlt, FaRegUser, FaBars, FaChevronDown, FaGlobe, FaQuestionCircle, FaUserEdit, FaSignOutAlt, FaSchool, FaUsers, FaShieldAlt, FaChartLine, FaTrophy, FaVideo, FaTimes, FaMoneyBillWave, FaChalkboardTeacher } from 'react-icons/fa';
import { MdReceiptLong } from 'react-icons/md';
import logo from './logo.png';
import { supabase } from './supabaseClient';
import { getApiBaseUrl } from './config/apiConfig';

export const SIDEBAR_WIDTH = 285;

const getSidebarMenu = (userRole, isArabic, requestCount = 0, chatCount = 0) => {
  if (isArabic) {
    // Arabic order and labels
    if (userRole === 'admin') {
      return [
        { label: 'نظرة عامة', icon: <FaChartLine size={18} />, route: '/dashboard/admin/overview' },
        { label: 'المستخدمين', icon: <FaUsers size={18} />, route: '/dashboard/admin/users' },
        { label: 'الحجوزات', icon: <MdReceiptLong size={20} />, route: '/dashboard/admin/bookings' },
        { label: 'تتبع الجلسات', icon: <FaVideo size={18} />, route: '/dashboard/admin/sessions' },
        { label: 'المدفوعات', icon: <FaMoneyBillWave size={18} />, route: '/dashboard/admin/payments' },
        { label: 'مكافآت المستويات', icon: <FaTrophy size={18} />, route: '/dashboard/admin/rewards' },
        { label: 'الأمان', icon: <FaShieldAlt size={18} />, route: '/dashboard/admin/security' },
        { label: 'مراقبة المحادثات', icon: <FaRegCommentDots size={18} />, route: '/dashboard/admin/chat' },
        { label: 'الحساب', icon: <FaRegUser size={18} />, route: '/dashboard/admin/profile' },
      ];
    } else if (userRole === 'teacher') {
      return [
        { label: 'الصفحة الرئيسية', icon: <FaRegEye size={18} />, route: '/dashboard/teacher/dashboard' },
        { label: 'الطلبات', icon: <MdReceiptLong size={20} />, route: '/dashboard/teacher/requests', badge: requestCount },
        { label: 'محادثة', icon: <FaRegCommentDots size={18} />, route: '/dashboard/teacher/chat', badge: chatCount },
        { label: 'تقويم', icon: <FaRegCalendarAlt size={18} />, route: '/dashboard/teacher/calendar' },
        { label: 'لوحة المتصدرين', icon: <FaTrophy size={18} />, route: '/dashboard/teacher/leaderboard' },
        { label: 'حساب', icon: <FaRegUser size={18} />, route: '/dashboard/teacher/profile' },
      ];
    } else {
      // Student Arabic menu
      return [
        { label: 'الصفحة الرئيسية', icon: <FaRegEye size={18} />, route: '/dashboard/student/dashboard' },
        { label: 'المعلمون', icon: <FaChalkboardTeacher size={18} />, route: '/dashboard/student/teachers' },
        { label: 'المعاهد', icon: <FaSchool size={18} />, route: '/dashboard/student/institutes' },
        { label: 'الطلبات', icon: <MdReceiptLong size={20} />, route: '/dashboard/student/requests', badge: requestCount },
        { label: 'محادثة', icon: <FaRegCommentDots size={18} />, route: '/dashboard/student/chat', badge: chatCount },
        { label: 'تقويم', icon: <FaRegCalendarAlt size={18} />, route: '/dashboard/student/calendar' },
        { label: 'حساب', icon: <FaRegUser size={18} />, route: '/dashboard/student/profile' },
      ];
    }
  } else {
    if (userRole === 'admin') {
      return [
        { label: 'Overview', icon: <FaChartLine size={18} />, route: '/dashboard/admin/overview' },
        { label: 'Users', icon: <FaUsers size={18} />, route: '/dashboard/admin/users' },
        { label: 'Bookings', icon: <MdReceiptLong size={20} />, route: '/dashboard/admin/bookings' },
        { label: 'Sessions', icon: <FaVideo size={18} />, route: '/dashboard/admin/sessions' },
        { label: 'Payments', icon: <FaMoneyBillWave size={18} />, route: '/dashboard/admin/payments' },
        { label: 'Level Rewards', icon: <FaTrophy size={18} />, route: '/dashboard/admin/rewards' },
        { label: 'Security', icon: <FaShieldAlt size={18} />, route: '/dashboard/admin/security' },
        { label: 'Chat Monitoring', icon: <FaRegCommentDots size={18} />, route: '/dashboard/admin/chat' },
        { label: 'Profile', icon: <FaRegUser size={18} />, route: '/dashboard/admin/profile' },
      ];
    } else if (userRole === 'teacher') {
      return [
        { label: 'Dashboard', icon: <FaRegEye size={18} />, route: '/dashboard/teacher/dashboard' },
        { label: 'Requests', icon: <MdReceiptLong size={20} />, route: '/dashboard/teacher/requests', badge: requestCount },
        { label: 'Chat', icon: <FaRegCommentDots size={18} />, route: '/dashboard/teacher/chat', badge: chatCount },
        { label: 'Calendar', icon: <FaRegCalendarAlt size={18} />, route: '/dashboard/teacher/calendar' },
        { label: 'Leaderboard', icon: <FaTrophy size={18} />, route: '/dashboard/teacher/leaderboard' },
        { label: 'Profile', icon: <FaRegUser size={18} />, route: '/dashboard/teacher/profile' },
      ];
    } else {
      return [
        { label: 'Dashboard', icon: <FaRegEye size={18} />, route: '/dashboard/student/dashboard' },
        { label: 'Teachers', icon: <FaChalkboardTeacher size={18} />, route: '/dashboard/student/teachers' },
        { label: 'Institutes', icon: <FaSchool size={18} />, route: '/dashboard/student/institutes' },
        { label: 'Requests', icon: <MdReceiptLong size={20} />, route: '/dashboard/student/requests', badge: requestCount },
        { label: 'Chat', icon: <FaRegCommentDots size={18} />, route: '/dashboard/student/chat', badge: chatCount },
        { label: 'Calendar', icon: <FaRegCalendarAlt size={18} />, route: '/dashboard/student/calendar' },
        { label: 'Profile', icon: <FaRegUser size={18} />, route: '/dashboard/student/profile' },
      ];
    }
  }
};

const sidebarButtonStyle = {
  width: '90%',
  maxWidth: 220,
  height: 48,
  margin: '0 auto 16px auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  background: '#fff',
  color: '#FF7426',
  border: '1.5px solid #FF7426',
  borderRadius: 16,
  fontWeight: 700,
  fontSize: 16,
  cursor: 'pointer',
  boxShadow: '0 2px 8px #ffe5d1',
  fontFamily: "'IBM Plex Sans Arabic', Arial, sans-serif",
  transition: 'background 0.2s, color 0.2s, border 0.2s',
  padding: 0,
};

const sidebarButtonHover = {
  background: '#fff6f0',
  color: '#FF7426',
  border: '2px solid #FF7426',
};

export default function Sidebar({ isOpen, isVisible, setSidebarVisible, theme = 'light', userRole: _userRole, sidebarMenu: customSidebarMenu, dashboardRoute, isArabic: isArabicProp, onLanguageChange, requestCount = 0, chatCount = 0, cachedUserProfile }) {
  setSidebarVisible = typeof setSidebarVisible === 'function' ? setSidebarVisible : () => {};
  const navigate = useNavigate();
  const location = useLocation();
  const sidebarRef = useRef(null);
  const profileRef = useRef(null);
  const langRef = useRef(null);

  // Always get userRole from localStorage for accurate role
  const userRole = localStorage.getItem('userRole') || _userRole;

  // Use the prop directly instead of local state
  const isArabic = isArabicProp || false;

  console.log('[Sidebar] Received cached profile:', cachedUserProfile?.full_name);

  // Make responsive breakpoints reactive
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  const [isTablet, setIsTablet] = useState(window.innerWidth > 900 && window.innerWidth <= 1200);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
      setIsTablet(window.innerWidth > 900 && window.innerWidth <= 1200);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // State for user profile
  const defaultName = userRole === 'admin' ? (isArabic ? 'المسؤول' : 'Admin') :
                     userRole === 'teacher' ? (isArabic ? 'اسم المعلم' : 'Teacher Name') :
                     (isArabic ? 'اسم الطالب' : 'Student Name');
  const [userName, setUserName] = useState(defaultName);
  const [userAvatar, setUserAvatar] = useState(null);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [newPhone, setNewPhone] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [generatedOtp, setGeneratedOtp] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [phoneSuccess, setPhoneSuccess] = useState('');

  // OPTIMIZATION: Use cached profile from layout instead of fetching
  useEffect(() => {
    // If we have cached profile, use it
    if (cachedUserProfile) {
      console.log('✅ Sidebar: Using cached profile:', cachedUserProfile.full_name);

      // Use full_name - check if it exists and is not empty
      let displayName = null;
      if (cachedUserProfile.full_name && cachedUserProfile.full_name.trim() !== '') {
        displayName = cachedUserProfile.full_name.trim();
      } else {
        displayName = cachedUserProfile.name || cachedUserProfile.first_name || cachedUserProfile.last_name ||
                     (cachedUserProfile.first_name && cachedUserProfile.last_name ? `${cachedUserProfile.first_name} ${cachedUserProfile.last_name}` : null);
      }

      // If still no name found, use default
      if (!displayName || displayName.trim() === '') {
        displayName = userRole === 'admin' ? (isArabic ? 'المسؤول' : 'Admin') :
                     userRole === 'teacher' ? (isArabic ? 'اسم المعلم' : 'Teacher Name') :
                     (isArabic ? 'اسم الطالب' : 'Student Name');
      }

      setUserName(displayName);

      // Only set avatar if profile_photo exists and is not empty
      if (cachedUserProfile.profile_photo && cachedUserProfile.profile_photo.trim() !== '') {
        setUserAvatar(cachedUserProfile.profile_photo);
      } else {
        setUserAvatar(null);
      }

      return; // Exit early since we have cached data
    }

    // Fallback: If no cached profile (e.g., for admin/teacher), fetch from database
    async function fetchUserProfile() {
      const userEmail = localStorage.getItem('userEmail');
      console.log('⚠️ Sidebar: No cached profile, fetching for email:', userEmail);

      if (!userEmail) {
        console.log('⚠️ Sidebar: No email found in localStorage');
        return;
      }

      try {
        const { data: { user: authUser } } = await supabase.auth.getUser();
        let nameFromAuth = null;
        if (authUser?.user_metadata?.full_name) {
          nameFromAuth = authUser.user_metadata.full_name;
        } else if (authUser?.raw_user_meta_data?.full_name) {
          nameFromAuth = authUser.raw_user_meta_data.full_name;
        }

        let table = userRole === 'admin' ? 'admins' :
                   userRole === 'teacher' ? 'Teachers' : 'students';

        const { data, error} = await supabase
          .from(table)
          .select('full_name, profile_photo')
          .eq('email', userEmail)
          .single();

        if (error) {
          console.error('❌ Sidebar: Error fetching user profile:', error);
          if (nameFromAuth) {
            setUserName(nameFromAuth);
          }
          return;
        }

        if (data) {
          let displayName = null;
          if (data.full_name && data.full_name.trim() !== '') {
            displayName = data.full_name.trim();
          } else {
            displayName = data.name || data.first_name || data.last_name ||
                         (data.first_name && data.last_name ? `${data.first_name} ${data.last_name}` : null);
          }

          if (!displayName || displayName.trim() === '') {
            displayName = nameFromAuth;
          }

          if (!displayName || displayName.trim() === '') {
            displayName = userRole === 'admin' ? (isArabic ? 'المسؤول' : 'Admin') :
                         userRole === 'teacher' ? (isArabic ? 'اسم المعلم' : 'Teacher Name') :
                         (isArabic ? 'اسم الطالب' : 'Student Name');
          }

          setUserName(displayName);

          if (data.profile_photo && data.profile_photo.trim() !== '') {
            setUserAvatar(data.profile_photo);
          } else {
            setUserAvatar(null);
          }
        } else {
          if (nameFromAuth) {
            setUserName(nameFromAuth);
          }
        }
      } catch (err) {
        console.error('❌ Sidebar: Exception fetching user profile:', err);
      }
    }

    fetchUserProfile();
  }, [cachedUserProfile, userRole, isArabic]);

  function isActiveRoute(route) {
    // Exact match for dashboard routes to prevent false positives
    if (route === '/dashboard/student/dashboard' || route === '/dashboard/teacher/dashboard') {
      return location.pathname === route || location.pathname === route + '/';
    }
    // For other routes, use startsWith but ensure it's not matching a parent route incorrectly
    return location.pathname === route || location.pathname.startsWith(route + '/');
  }

  // Close profile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showProfileMenu && profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    };

    if (showProfileMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showProfileMenu]);

  // Handle logout
  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  // Send OTP to email
  const handleSendOTP = async () => {
    setPhoneError('');
    setPhoneSuccess('');

    // Validate phone number
    if (!newPhone || newPhone.length < 8) {
      setPhoneError(isArabic ? 'يرجى إدخال رقم هاتف صالح' : 'Please enter a valid phone number');
      return;
    }

    try {
      // Generate 6-digit OTP
      const otp = Math.floor(100000 + Math.random() * 900000).toString();
      setGeneratedOtp(otp);

      const userEmail = localStorage.getItem('userEmail');

      // Send OTP via email
      const response = await fetch(`${getApiBaseUrl()}/api/send-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: userEmail,
          otp: otp,
          userName: userName,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to send OTP');
      }

      setOtpSent(true);
      setPhoneSuccess(isArabic ? 'تم إرسال رمز التحقق إلى بريدك الإلكتروني' : 'OTP sent to your email');
    } catch (error) {
      console.error('Error sending OTP:', error);
      setPhoneError(isArabic ? 'فشل إرسال رمز التحقق' : 'Failed to send OTP');
    }
  };

  // Verify OTP and update phone
  const handleVerifyAndUpdate = async () => {
    setPhoneError('');
    setPhoneSuccess('');

    if (otpCode !== generatedOtp) {
      setPhoneError(isArabic ? 'رمز التحقق غير صحيح' : 'Invalid OTP code');
      return;
    }

    try {
      const userEmail = localStorage.getItem('userEmail');
      const table = userRole === 'teacher' ? 'Teachers' : 'students';

      const { error } = await supabase
        .from(table)
        .update({ phone: newPhone })
        .eq('email', userEmail);

      if (error) {
        throw error;
      }

      setPhoneSuccess(isArabic ? 'تم تحديث رقم الهاتف بنجاح' : 'Phone number updated successfully');
      setTimeout(() => {
        setShowPhoneModal(false);
        setNewPhone('');
        setOtpCode('');
        setOtpSent(false);
        setGeneratedOtp('');
        setPhoneSuccess('');
      }, 2000);
    } catch (error) {
      console.error('Error updating phone:', error);
      setPhoneError(isArabic ? 'فشل تحديث رقم الهاتف' : 'Failed to update phone number');
    }
  };

  const sidebarMenu = customSidebarMenu || getSidebarMenu(userRole, isArabic, requestCount, chatCount);
  
  // Debug: log the notification counts
  console.log('Sidebar notification counts:', { requestCount, chatCount });
  console.log('Sidebar menu items:', sidebarMenu);

  if (!isVisible) {
    return null;
  }

  // Handler for language toggle
  const handleLanguageToggle = () => {
    console.log('Language toggle clicked!');
    console.log('Current isArabic:', isArabic);
    console.log('onLanguageChange function:', typeof onLanguageChange);
    const newLang = !isArabic;
    console.log('New language will be:', newLang);
   
    // First, change the language
    if (typeof onLanguageChange === 'function') {
      console.log('Calling onLanguageChange with:', newLang);
      onLanguageChange(newLang);
      // Force a re-render by updating the state
      setTimeout(() => {
        console.log('Language changed');
      }, 50);
    } else {
      console.log('onLanguageChange is not a function');
    }
  };

  return (
    <>
      {isMobile && isVisible && (
        <div
          onClick={() => {}}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.4)',
            zIndex: 1999,
            backdropFilter: 'blur(2px)',
            transition: 'opacity 0.3s ease-in-out',
            opacity: 1,
          }}
        />
      )}
      <aside
        aria-label="Main menu sidebar"
        ref={sidebarRef}
        style={{
          width: isMobile ? '305px' : (isOpen ? SIDEBAR_WIDTH : 72),
          minWidth: 0,
          background: theme === 'dark' ? '#1E293B' : '#fff',
          boxShadow: isMobile ? '2px 0 16px rgba(0,0,0,0.1)' : '2px 0 8px #f0f0f0',
          borderRight: isArabic ? undefined : '1px solid #e0eaff',
          borderLeft: isArabic ? '1px solid #e0eaff' : undefined,
          display: 'flex',
          flexDirection: 'column',
          alignItems: isOpen ? 'flex-start' : 'center',
          padding: isMobile ? '20px 0 0 0' : '24px 0 0 0',
          position: 'fixed',
          left: isArabic ? 'auto' : (isMobile ? (isVisible ? 0 : '-305px') : 0),
          right: isArabic ? (isMobile ? (isVisible ? 0 : '-305px') : 0) : 'auto',
          top: 0,
          height: '100vh',
          zIndex: isMobile ? 2000 : 100,
          boxSizing: 'border-box',
          transition: isMobile ? (isArabic ? 'right 0.3s ease-in-out' : 'left 0.3s ease-in-out') : 'width 0.3s cubic-bezier(.4,2,.6,1)',
          direction: isArabic ? 'rtl' : 'ltr',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
        role="navigation"
        dir={isArabic ? 'rtl' : 'ltr'}
      >
        {/* Hamburger button inside sidebar, top right */}
        {/* User Profile Section */}
        <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: isOpen ? (isArabic ? 'flex-end' : 'space-between') : 'center', padding: isOpen ? (isArabic ? (isMobile ? '0 0 0 16px' : '0 0 0 20px') : (isMobile ? '0 16px' : '0 20px')) : '0', marginBottom: isMobile ? 12 : 18, position: 'relative', marginTop: isMobile ? '-8px' : '-10px' }}>
          {/* Logo clickable - Show logo and close button on mobile, logo on desktop */}
          {isMobile ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%', justifyContent: 'space-between', flexDirection: 'row' }}>
              <button
                onClick={() => setSidebarVisible(false)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 8,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#232B3E',
                  borderRadius: 8,
                  transition: 'background 0.2s',
                  flexShrink: 0,
                  order: isArabic ? 2 : 1
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#f1f5f9';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'transparent';
                }}
                aria-label={isArabic ? "إغلاق القائمة" : "Close sidebar"}
              >
                <FaTimes size={24} />
              </button>
              <a 
                href={dashboardRoute || (userRole === 'teacher' ? '/dashboard/teacher/dashboard' : '/dashboard/student/dashboard')} 
                style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', order: isArabic ? 1 : 2 }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(dashboardRoute || (userRole === 'teacher' ? '/dashboard/teacher/dashboard' : '/dashboard/student/dashboard'));
                }}
              >
                <img src={logo} alt="Taealam Logo" style={{ width: isOpen ? 48 : 32, transition: 'width 0.2s' }} />
              </a>
            </div>
          ) : (
            <a 
              href={dashboardRoute || (userRole === 'teacher' ? '/dashboard/teacher/dashboard' : '/dashboard/student/dashboard')} 
              style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
              onClick={(e) => {
                e.preventDefault();
                navigate(dashboardRoute || (userRole === 'teacher' ? '/dashboard/teacher/dashboard' : '/dashboard/student/dashboard'));
              }}
            >
              <img src={logo} alt="Taealam Logo" style={{ width: isOpen ? 48 : 32, transition: 'width 0.2s' }} />
            </a>
          )}
        </div>
        {/* MAIN MENU label - only show when isOpen */}
        {isOpen && (
          <div style={{ width: '100%', paddingLeft: isArabic ? 0 : (isMobile ? 16 : 20), paddingRight: isArabic ? (isMobile ? 16 : 20) : 0, marginBottom: isMobile ? 12 : 18, color: '#cbd5e1', fontSize: isMobile ? 11 : 13, letterSpacing: 1, fontWeight: 700, textAlign: isArabic ? 'right' : 'left' }}>{isArabic ? 'القائمة الرئيسية' : 'MAIN MENU'}</div>
        )}
        <nav style={{ width: '100%' }} aria-label="Main menu">
          {sidebarMenu.map((item) => {
            const isActive = isActiveRoute(item.route);
            return (
              <div
                key={item.label}
                tabIndex={0}
                aria-label={item.label}
                role="menuitem"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: isArabic ? 'row-reverse' : 'row',
                  gap: isOpen ? (isMobile ? 10 : 14) : 0,
                  padding: isOpen ? (isMobile ? '10px 16px' : '8px 20px') : '8px 0',
                  width: '100%',
                  background: isActive ? 'none' : 'none',
                  color: isActive ? (theme === 'dark' ? '#232B3E' : '#232B3E') : '#7b8bb7',
                  fontWeight: isActive ? 700 : 500,
                  fontSize: isMobile ? 15 : 16,
                  borderRadius: 12,
                  marginBottom: 0,
                  cursor: 'pointer',
                  borderLeft: !isArabic && isActive ? (isMobile ? '4px solid #FF7426' : '6px solid #FF7426') : (isMobile ? '4px solid transparent' : '6px solid transparent'),
                  borderRight: isArabic && isActive ? (isMobile ? '4px solid #FF7426' : '6px solid #FF7426') : (isMobile ? '4px solid transparent' : '6px solid transparent'),
                  outline: 'none',
                  position: 'relative',
                  transition: 'background 0.2s, border-left 0.2s, border-right 0.2s',
                  minHeight: isMobile ? 48 : 44,
                  justifyContent: isOpen ? (isArabic ? 'flex-end' : 'flex-start') : 'center',
                  textAlign: isArabic ? 'right' : 'left',
                }}
                onClick={() => {
                  navigate(item.route);
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    navigate(item.route);
                  }
                }}
                onMouseOver={e => { if (!isActive) e.currentTarget.style.background = 'none'; }}
                onMouseOut={e => { if (!isActive) e.currentTarget.style.background = 'none'; }}
                title={!isOpen ? item.label : undefined}
              >
                {isArabic ? (
                  <>
                    <span style={{ 
                      color: isActive ? '#232B3E' : '#7b8bb7', 
                      fontWeight: isActive ? 700 : 500, 
                      flex: 1, 
                      display: 'flex', 
                      alignItems: 'center', 
                      position: 'relative', 
                      justifyContent: 'flex-start',
                      textAlign: 'right',
                      direction: 'rtl',
                      marginRight: isOpen ? (isMobile ? 10 : 14) : 0
                    }}>
                      {item.label}
                      {item.badge > 0 && (
                        <span style={{
                          marginLeft: isMobile ? 8 : 12,
                          background: '#FF7426',
                          color: '#fff',
                          borderRadius: isMobile ? 10 : 12,
                          fontSize: isMobile ? 11 : 13,
                          fontWeight: 700,
                          padding: isMobile ? '0 6px' : '0 10px',
                          minWidth: isMobile ? 18 : 20,
                          textAlign: 'center',
                          lineHeight: isMobile ? '18px' : '20px',
                          height: isMobile ? 20 : 22,
                          display: 'inline-block',
                          boxShadow: '0 1px 4px #ffd6b8',
                          verticalAlign: 'middle',
                        }}>{item.badge}</span>
                      )}
                    </span>
                    <span style={{ 
                      fontSize: isMobile ? 18 : 20, 
                      color: isActive ? '#232B3E' : '#b0bed9', 
                      margin: isOpen ? 0 : '0 auto', 
                      display: 'flex', 
                      alignItems: 'center', 
                      position: 'relative', 
                      minWidth: isMobile ? 24 : 28, 
                      maxWidth: isMobile ? 24 : 28,
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      {item.icon}
                    </span>
                  </>
                ) : (
                  <>
                    <span style={{ fontSize: isMobile ? 18 : 20, color: isActive ? '#232B3E' : '#b0bed9', margin: isOpen ? 0 : '0 auto', display: 'flex', alignItems: 'center', position: 'relative', minWidth: isMobile ? 24 : 28, justifyContent: 'center' }}>
                      {item.icon}
                    </span>
                    <span style={{ color: isActive ? '#232B3E' : '#7b8bb7', fontWeight: isActive ? 700 : 500, flex: 1, display: 'flex', alignItems: 'center', position: 'relative', justifyContent: 'flex-start' }}>
                      {item.label}
                      {item.badge > 0 && (
                        <span style={{
                          marginLeft: isMobile ? 8 : 12,
                          background: '#FF7426',
                          color: '#fff',
                          borderRadius: isMobile ? 10 : 12,
                          fontSize: isMobile ? 11 : 13,
                          fontWeight: 700,
                          padding: isMobile ? '0 6px' : '0 10px',
                          minWidth: isMobile ? 18 : 20,
                          textAlign: 'center',
                          lineHeight: isMobile ? '18px' : '20px',
                          height: isMobile ? 20 : 22,
                          display: 'inline-block',
                          boxShadow: '0 1px 4px #ffd6b8',
                          verticalAlign: 'middle',
                        }}>{item.badge}</span>
                      )}
                    </span>
                  </>
                )}
                {/* Tooltip for collapsed menu */}
                {!isOpen && <span style={{ position: 'absolute', left: 60, background: '#232B3E', color: '#fff', borderRadius: 6, padding: '2px 8px', fontSize: 13, opacity: 0, pointerEvents: 'none', transition: 'opacity 0.2s' }} className="sidebar-tooltip">{item.label}</span>}
              </div>
            );
          })}
        </nav>
        {/* Divider */}
        <div style={{ width: '100%', height: 1, background: '#e0eaff', margin: isOpen ? (isMobile ? '14px 0' : '18px 0') : '12px 0' }} />
        {/* Language Switcher */}
        {isOpen && (
          <div ref={langRef} style={{ width: '100%', margin: '0 auto 0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
            <button
              aria-label="Language"
              style={{
                ...sidebarButtonStyle,
                width: isMobile ? '85%' : sidebarButtonStyle.width,
                maxWidth: isMobile ? 200 : sidebarButtonStyle.maxWidth,
                height: isMobile ? 44 : sidebarButtonStyle.height,
                fontSize: isMobile ? 14 : sidebarButtonStyle.fontSize,
                marginBottom: isMobile ? 12 : sidebarButtonStyle.margin.split(' ')[2],
              }}
              onMouseOver={e => Object.assign(e.currentTarget.style, sidebarButtonHover)}
              onMouseOut={e => Object.assign(e.currentTarget.style, {
                ...sidebarButtonStyle,
                width: isMobile ? '85%' : sidebarButtonStyle.width,
                maxWidth: isMobile ? 200 : sidebarButtonStyle.maxWidth,
                height: isMobile ? 44 : sidebarButtonStyle.height,
                fontSize: isMobile ? 14 : sidebarButtonStyle.fontSize,
              })}
              tabIndex={0}
              onClick={handleLanguageToggle}
            >
              <FaGlobe size={isMobile ? 16 : 18} /> <span style={{ fontFamily: "'IBM Plex Sans Arabic', sans-serif", fontWeight: 600 }}>{isArabic ? 'English' : 'العربية'}</span>
            </button>
          </div>
        )}
        {/* Help Center Button */}
        <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: isMobile ? 10 : 12 }}>
          <button
            aria-label="Help Center"
            onClick={() => navigate(`/dashboard/${userRole}/help-center`)}
            style={{
              ...sidebarButtonStyle,
              width: isMobile ? '85%' : sidebarButtonStyle.width,
              maxWidth: isMobile ? 200 : sidebarButtonStyle.maxWidth,
              height: isMobile ? 44 : sidebarButtonStyle.height,
              fontSize: isMobile ? 14 : sidebarButtonStyle.fontSize,
              marginBottom: isMobile ? 12 : sidebarButtonStyle.margin.split(' ')[2],
            }}
            onMouseOver={e => Object.assign(e.currentTarget.style, sidebarButtonHover)}
            onMouseOut={e => Object.assign(e.currentTarget.style, {
              ...sidebarButtonStyle,
              width: isMobile ? '85%' : sidebarButtonStyle.width,
              maxWidth: isMobile ? 200 : sidebarButtonStyle.maxWidth,
              height: isMobile ? 44 : sidebarButtonStyle.height,
              fontSize: isMobile ? 14 : sidebarButtonStyle.fontSize,
            })}
            tabIndex={0}
          >
            <FaQuestionCircle size={isMobile ? 16 : 18} /> {isOpen && (isArabic ? 'مركز المساعدة' : 'Help Center')}
          </button>
        </div>
        {/* Place profile avatar at the bottom - Always visible */}
        <div style={{ marginTop: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', paddingBottom: isMobile ? 8 : 0, position: 'relative' }}>
            <div
              ref={profileRef}
              style={{
                ...sidebarButtonStyle,
                gap: isMobile ? 8 : 12,
                position: 'relative',
                fontWeight: 700,
                fontSize: isMobile ? 15 : 17,
                margin: isMobile ? '0 auto 12px auto' : '0 auto 16px auto',
                cursor: 'pointer',
                paddingLeft: isOpen ? (isMobile ? 10 : 12) : (isMobile ? 8 : 10),
                paddingRight: isOpen ? (isMobile ? 10 : 12) : (isMobile ? 8 : 10),
                display: 'flex',
                alignItems: 'center',
                justifyContent: isOpen ? 'space-between' : 'center',
                width: isOpen ? (isMobile ? '85%' : sidebarButtonStyle.width) : (isMobile ? '85%' : '100%'),
                maxWidth: isOpen ? (isMobile ? 200 : sidebarButtonStyle.maxWidth) : (isMobile ? 200 : '100%'),
                height: isMobile ? 44 : sidebarButtonStyle.height,
              }}
              tabIndex={0}
              aria-haspopup="true"
              aria-expanded={showProfileMenu}
              onClick={() => setShowProfileMenu(!showProfileMenu)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setShowProfileMenu(!showProfileMenu);
                }
              }}
            >
              <div style={{ position: 'relative', width: '100%', display: 'flex', alignItems: 'center', justifyContent: isOpen ? 'space-between' : 'center', gap: isOpen ? 8 : 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', flex: isOpen ? 1 : 'none', minWidth: 0, gap: isOpen ? (isMobile ? 8 : 12) : (isMobile ? 4 : 6) }}>
                  {userAvatar ? (
                    <img src={userAvatar} alt="User Avatar" style={{ width: isMobile ? 32 : 36, height: isMobile ? 32 : 36, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
                  ) : (
                    <div style={{ 
                      width: isMobile ? 32 : 36, 
                      height: isMobile ? 32 : 36, 
                      borderRadius: '50%', 
                      background: '#e0eaff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#9ca3af',
                      fontSize: isMobile ? 14 : 16,
                      fontWeight: 600,
                      flexShrink: 0
                    }}>
                      {userName.charAt(0).toUpperCase()}
                    </div>
                  )}
                  <span style={{ 
                    flex: isOpen ? 1 : 'none',
                    textAlign: isOpen ? (isArabic ? 'right' : 'left') : 'center', 
                    fontWeight: 700, 
                    color: theme === 'dark' ? '#1E293B' : '#1E293B', 
                    fontSize: isMobile ? 12 : 13, 
                    fontFamily: "'IBM Plex Sans Arabic', Arial, sans-serif", 
                    whiteSpace: 'nowrap', 
                    overflow: 'hidden', 
                    textOverflow: 'ellipsis',
                    minWidth: 0,
                    maxWidth: !isOpen ? (isMobile ? '120px' : '140px') : 'none',
                    display: 'block'
                  }}>{userName}</span>
                </div>
                {isOpen && (
                  <FaChevronDown
                    size={isMobile ? 11 : 13}
                    color="#FF7426"
                    style={{ flexShrink: 0, transform: `rotate(${showProfileMenu ? '0deg' : '180deg'})`, transition: 'transform 0.2s' }}
                  />
                )}
              </div>

              {/* Dropdown Menu */}
              {showProfileMenu && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: '100%',
                    left: isOpen ? '50%' : (isArabic ? 'auto' : 0),
                    right: isOpen ? 'auto' : (isArabic ? 0 : 'auto'),
                    transform: isOpen ? 'translateX(-50%)' : 'none',
                    background: '#fff',
                    borderRadius: 12,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    padding: '8px 0',
                    marginBottom: 8,
                    minWidth: 180,
                    zIndex: 1000,
                    border: '1px solid #e0eaff'
                  }}
                >
                  <button
                    onClick={() => {
                      const profileRoute = userRole === 'admin' ? '/dashboard/admin/profile' :
                                          userRole === 'teacher' ? '/dashboard/teacher/profile' :
                                          '/dashboard/student/profile';
                      navigate(profileRoute);
                      setShowProfileMenu(false);
                    }}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      background: 'none',
                      border: 'none',
                      textAlign: 'left',
                      cursor: 'pointer',
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#232B3E',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                      transition: 'background 0.2s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.background = '#f8f8fa'}
                    onMouseOut={(e) => e.currentTarget.style.background = 'none'}
                  >
                    <FaRegUser size={16} color="#667eea" />
                    <span>{isArabic ? 'عرض الملف الشخصي' : 'View Profile'}</span>
                  </button>
                  <div style={{ height: 1, background: '#e0eaff', margin: '4px 0' }} />
                  <button
                    onClick={() => {
                      setShowPhoneModal(true);
                      setShowProfileMenu(false);
                    }}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      background: 'none',
                      border: 'none',
                      textAlign: 'left',
                      cursor: 'pointer',
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#232B3E',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                      transition: 'background 0.2s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.background = '#f8f8fa'}
                    onMouseOut={(e) => e.currentTarget.style.background = 'none'}
                  >
                    <FaUserEdit size={16} color="#667eea" />
                    <span>{isArabic ? 'تغيير رقم الهاتف' : 'Change Phone Number'}</span>
                  </button>
                  <div style={{ height: 1, background: '#e0eaff', margin: '4px 0' }} />
                  <button
                    onClick={handleLogout}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      background: 'none',
                      border: 'none',
                      textAlign: 'left',
                      cursor: 'pointer',
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#EF4444',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                      transition: 'background 0.2s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.background = '#fef2f2'}
                    onMouseOut={(e) => e.currentTarget.style.background = 'none'}
                  >
                    <FaSignOutAlt size={16} color="#EF4444" />
                    <span>{isArabic ? 'تسجيل الخروج' : 'Logout'}</span>
                  </button>
                </div>
              )}
            </div>
          </div>
      </aside>

      {/* Phone Change Modal */}
      {showPhoneModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            fontFamily: "'IBM Plex Sans Arabic', Arial, sans-serif"
          }}
          onClick={() => {
            setShowPhoneModal(false);
            setNewPhone('');
            setOtpCode('');
            setOtpSent(false);
            setPhoneError('');
            setPhoneSuccess('');
          }}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: 20,
              padding: isMobile ? '24px' : '32px',
              maxWidth: 450,
              width: '90%',
              boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 style={{ margin: '0 0 24px 0', fontSize: 24, fontWeight: 700, color: '#232B3E' }}>
              {isArabic ? 'تغيير رقم الهاتف' : 'Change Phone Number'}
            </h2>

            {!otpSent ? (
              <>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ display: 'block', marginBottom: 8, fontSize: 14, fontWeight: 600, color: '#232B3E' }}>
                    {isArabic ? 'رقم الهاتف الجديد' : 'New Phone Number'}
                  </label>
                  <input
                    type="tel"
                    value={newPhone}
                    onChange={(e) => setNewPhone(e.target.value)}
                    placeholder={isArabic ? 'أدخل رقم الهاتف الجديد' : 'Enter new phone number'}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      borderRadius: 12,
                      border: '2px solid #e0eaff',
                      fontSize: 15,
                      outline: 'none',
                      transition: 'border 0.2s',
                      fontFamily: "'IBM Plex Sans Arabic', Arial, sans-serif"
                    }}
                    onFocus={(e) => e.target.style.border = '2px solid #FF7426'}
                    onBlur={(e) => e.target.style.border = '2px solid #e0eaff'}
                  />
                </div>

                {phoneError && (
                  <div style={{ padding: '12px 16px', background: '#FEE2E2', border: '1px solid #FCA5A5', borderRadius: 8, marginBottom: 16, color: '#DC2626', fontSize: 14 }}>
                    {phoneError}
                  </div>
                )}

                {phoneSuccess && (
                  <div style={{ padding: '12px 16px', background: '#D1FAE5', border: '1px solid #6EE7B7', borderRadius: 8, marginBottom: 16, color: '#059669', fontSize: 14 }}>
                    {phoneSuccess}
                  </div>
                )}

                <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
                  <button
                    onClick={handleSendOTP}
                    style={{
                      flex: 1,
                      padding: '14px 24px',
                      background: '#FF7426',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 12,
                      fontSize: 16,
                      fontWeight: 700,
                      cursor: 'pointer',
                      transition: 'background 0.2s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.background = '#e66620'}
                    onMouseOut={(e) => e.currentTarget.style.background = '#FF7426'}
                  >
                    {isArabic ? 'إرسال رمز التحقق' : 'Send OTP'}
                  </button>
                  <button
                    onClick={() => {
                      setShowPhoneModal(false);
                      setNewPhone('');
                      setPhoneError('');
                      setPhoneSuccess('');
                    }}
                    style={{
                      flex: 1,
                      padding: '14px 24px',
                      background: '#e0eaff',
                      color: '#232B3E',
                      border: 'none',
                      borderRadius: 12,
                      fontSize: 16,
                      fontWeight: 700,
                      cursor: 'pointer',
                      transition: 'background 0.2s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.background = '#cbd5e1'}
                    onMouseOut={(e) => e.currentTarget.style.background = '#e0eaff'}
                  >
                    {isArabic ? 'إلغاء' : 'Cancel'}
                  </button>
                </div>
              </>
            ) : (
              <>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ display: 'block', marginBottom: 8, fontSize: 14, fontWeight: 600, color: '#232B3E' }}>
                    {isArabic ? 'رمز التحقق' : 'Verification Code'}
                  </label>
                  <input
                    type="text"
                    value={otpCode}
                    onChange={(e) => setOtpCode(e.target.value)}
                    placeholder={isArabic ? 'أدخل رمز التحقق المرسل إلى بريدك' : 'Enter OTP sent to your email'}
                    maxLength={6}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      borderRadius: 12,
                      border: '2px solid #e0eaff',
                      fontSize: 15,
                      outline: 'none',
                      transition: 'border 0.2s',
                      fontFamily: "'IBM Plex Sans Arabic', Arial, sans-serif",
                      letterSpacing: 4,
                      textAlign: 'center',
                      fontSize: 20,
                      fontWeight: 700
                    }}
                    onFocus={(e) => e.target.style.border = '2px solid #FF7426'}
                    onBlur={(e) => e.target.style.border = '2px solid #e0eaff'}
                  />
                </div>

                {phoneError && (
                  <div style={{ padding: '12px 16px', background: '#FEE2E2', border: '1px solid #FCA5A5', borderRadius: 8, marginBottom: 16, color: '#DC2626', fontSize: 14 }}>
                    {phoneError}
                  </div>
                )}

                {phoneSuccess && (
                  <div style={{ padding: '12px 16px', background: '#D1FAE5', border: '1px solid #6EE7B7', borderRadius: 8, marginBottom: 16, color: '#059669', fontSize: 14 }}>
                    {phoneSuccess}
                  </div>
                )}

                <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
                  <button
                    onClick={handleVerifyAndUpdate}
                    style={{
                      flex: 1,
                      padding: '14px 24px',
                      background: '#10B981',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 12,
                      fontSize: 16,
                      fontWeight: 700,
                      cursor: 'pointer',
                      transition: 'background 0.2s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.background = '#059669'}
                    onMouseOut={(e) => e.currentTarget.style.background = '#10B981'}
                  >
                    {isArabic ? 'تأكيد وتحديث' : 'Verify & Update'}
                  </button>
                  <button
                    onClick={() => {
                      setShowPhoneModal(false);
                      setNewPhone('');
                      setOtpCode('');
                      setOtpSent(false);
                      setPhoneError('');
                      setPhoneSuccess('');
                    }}
                    style={{
                      flex: 1,
                      padding: '14px 24px',
                      background: '#e0eaff',
                      color: '#232B3E',
                      border: 'none',
                      borderRadius: 12,
                      fontSize: 16,
                      fontWeight: 700,
                      cursor: 'pointer',
                      transition: 'background 0.2s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.background = '#cbd5e1'}
                    onMouseOut={(e) => e.currentTarget.style.background = '#e0eaff'}
                  >
                    {isArabic ? 'إلغاء' : 'Cancel'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
} 